/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, useCallback } from 'react';
import pt from './pt';
import en from './en';

const DICTS = { pt, en };
const STORE_KEY = 'glk_lang';
const I18nContext = createContext(null);

function resolve(dict, key) {
  return key.split('.').reduce((o, k) => (o == null ? o : o[k]), dict);
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(STORE_KEY);
    if (saved === 'pt' || saved === 'en') return saved;
    return (navigator.language || '').toLowerCase().startsWith('en') ? 'en' : 'pt';
  });

  const setLang = useCallback((l) => {
    if (l !== 'pt' && l !== 'en') return;
    localStorage.setItem(STORE_KEY, l);
    setLangState(l);
    document.documentElement.setAttribute('lang', l);
  }, []);

  const t = useCallback((key, vars) => {
    let s = resolve(DICTS[lang], key);
    if (s == null) s = resolve(pt, key);      // fall back to PT, then the key
    if (s == null) return key;
    if (vars && typeof s === 'string') {
      for (const [k, v] of Object.entries(vars)) s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
    }
    return s;
  }, [lang]);

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
